import Page from "webPage/Page";
import CanvasImage from "CanvasImage";

Page.register('/discrimination', function () {

    let masksProcess = {
        0: [
            {
                'url': '/images/png/masks/home/process/home-process-mask--top.png',
                'vPos': 'top',
                'hPos': 'center'
            },
            {
                'url': '/images/png/masks/home/process/home-process-mask--bottom.png',
                'vPos': 'bottom',
                'hPos': 'center'
            }
        ],
        600: [
            {
                'url': '/images/png/masks/home/process/home-process-mask--top.png',
                'vPos': 'top',
                'hPos': 'center'
            },
            {
                'url': '/images/png/masks/home/process/home-process-mask--bottom.png',
                'vPos': 'bottom',
                'hPos': 'center'
            }
        ],
        960: [
            {
                'url': '/images/png/masks/home/process/home-process-mask--top.png',
                'vPos': 'top',
                'hPos': 'center'
            },
            {
                'url': '/images/png/masks/home/process/home-process-mask--bottom.png',
                'vPos': 'bottom',
                'hPos': 'center'
            }
        ]
    };


    let masksContent = {
        0: [
            {
                'url': '/images/png/masks/discrimination/content__image-discrimination--mobile-mask.png',
                'vPos': 'top'
            }
        ],
        600: [
            {
                'url': '/images/png/masks/discrimination/content__image-discrimination--tablet-mask.png',
                'vPos': 'center'
            }
        ],
        1200: [
            {
                'url': '/images/png/masks/discrimination/content__image-discrimination--desktop-mask.png',
                'vPos': 'top'
            }
        ]
    };


    new CanvasImage($('.content__img'), masksContent);

    new CanvasImage($('.process__background'), masksProcess);
});
